module.exports = __webpack_public_path__ + "img/LOGO_643_1_2.5d4f3d4c.svg";